import { SET_HAS_UNREAD_NOTI } from 'redux/action/type'

interface INotificationReduxState {
  hasUnreadNotifications: boolean
}

interface INotificationReduxAction {
  type: string
  payload: INotificationReduxState
}

const initialState: INotificationReduxState = {
  hasUnreadNotifications: false,
}

const notificationReducer = (
  state: INotificationReduxState = initialState,
  action: INotificationReduxAction,
): INotificationReduxState => {
  switch (action.type) {
    case SET_HAS_UNREAD_NOTI:
      return {
        ...state,
        hasUnreadNotifications: action?.payload?.hasUnreadNotifications,
      }
    default:
      return state
  }
}

export default notificationReducer
